import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    EmvioValidatedForm,
    EmvioValidatedButton
} from '@nexio/emvio-form-components';

export default class ConfirmVerificationCodeReceived extends Component {
    static propTypes = {
        email: PropTypes.string,
        onReturnToLogin: PropTypes.func,
        onVerificationCodeReceived: PropTypes.func
    };

    render() {
        return (
            <div>
                <EmvioValidatedForm
                    className="confirm-verification-code-form"
                    onSubmit={this.props.onReturnToLogin}>
                    <div className="forgot-password-instructions">
                        An email has been sent to <b>{` ${this.props.email}`}</b> with instructions on how to reset your password.
                    </div>
                    <EmvioValidatedButton>
                        RETURN TO SIGN IN PAGE
                    </EmvioValidatedButton>
                </EmvioValidatedForm>
            </div>
        );
    }
}
